import { render, staticRenderFns } from "./MobileAppSettingsTab.vue?vue&type=template&id=cafbf8aa&scoped=true"
import script from "./MobileAppSettingsTab.vue?vue&type=script&lang=js"
export * from "./MobileAppSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafbf8aa",
  null
  
)

export default component.exports